import {post,get} from '../libs/ajax.js'

export default {
    // 获取筛选条件
    getOPPOConditions: (data, options) => {
        return post('/data_analysis/oppo/get_condition', data, options)
    },
    getMiConditions: (data, options) => {
        return post('/data_analysis/mi/get_condition', data, options)
    },
    getMiv4Conditions: (data, options) => {
        return post('/data_analysis/mi_v4/get_condition', data, options)
    },
    getVivoConditions: (data, options) => {
        return post('/data_analysis/vivo/get_condition', data, options)
    },
    getHuaweiConditions: (data, options) => {
        return post('/data_analysis/huawei/get_condition', data, options)
    },
    getIQiYiConditions: (data, options) => {
        return post('/data_analysis/iqiyi/get_condition', data, options)
    },
    getAppleConditions: (data, options) => {
        return post('/data_analysis/apple/get_condition', data, options)
    },
    getHuaweiADSConditions: (data, options) => {
        return post('/data_analysis/huaweiads/get_condition', data, options)
    },
    getHonorConditions: (data, options) => {
        return post('/data_analysis/honor/get_condition', data, options)
    },
    getMiGlobalConditions: (data, options) => {
        return post('/data_analysis/mi_global/get_condition', data, options)
    },
    getPlatConditions: (data, options) => {
        return post('/data_analysis/plat/get_condition', data, options)
    },
    // 获取不可用日期
    getOPPODisableDate: (data, options) => {
        return post('/data_analysis/oppo/get_disable_date', data, options)
    },
    getMiDisableDate: (data, options) => {
        return post('/data_analysis/mi/get_disable_date', data, options)
    },
    getMiv4DisableDate: (data, options) => {
        return post('/data_analysis/mi_v4/get_disable_date', data, options)
    },
    getVivoDisableDate: (data, options) => {
        return post('/data_analysis/vivo/get_disable_date', data, options)
    },
    // vivo 综合查询分析-消耗指标小数位配置
    getVivoCostDecimal: (data, options) => {
        return get('/data_analysis/vivo/cost_decimal/get', data, options)
    },
    setVivoCostDecimal: (data, options) => {
        return post('/data_analysis/vivo/cost_decimal/set', data, options)
    },
    getHuaweiDisableDate: (data, options) => {
        return post('/data_analysis/huawei/get_disable_date', data, options)
    },
    getIQiYiDisableDate: (data, options) => {
        return post('/data_analysis/iqiyi/get_disable_date', data, options)
    },
    getAppleDisableDate: (data, options) => {
        return post('/data_analysis/apple/get_disable_date', data, options)
    },
    getHuaweiADSDisableDate: (data, options) => {
        return post('/data_analysis/huaweiads/get_disable_date', data, options)
    },
    getHonorDisableDate: (data, options) => {
        return post('/data_analysis/honor/get_disable_date', data, options)
    },
    getMiGlobalDisableDate: (data, options) => {
        return post('/data_analysis/mi_global/get_disable_date', data, options)
    },
    getPlatDisableDate: (data, options) => {
        return post('/data_analysis/plat/get_disable_date', data, options)
    },
    // 获取列表
    getOPPOAnalysisList: (data, options) => {
        return post('/data_analysis/oppo/get_list', data, options)
    },
    getMiAnalysisList: (data, options) => {
        return post('/data_analysis/mi/get_list', data, options)
    },
    getMiv4AnalysisList: (data, options) => {
        return post('/data_analysis/mi_v4/get_list', data, options)
    },
    getVivoAnalysisList: (data, options) => {
        return post('/data_analysis/vivo/get_list', data, options)
    },
    getHuaweiAnalysisList: (data, options) => {
        return post('/data_analysis/huawei/get_list', data, options)
    },
    getIQiYiAnalysisList: (data, options) => {
        return post('/data_analysis/iqiyi/get_list', data, options)
    },
    getAppleAnalysisList: (data, options) => {
        return post('/data_analysis/apple/get_list', data, options)
    },
    getHuaweiADSAnalysisList: (data, options) => {
        return post('/data_analysis/huaweiads/get_list', data, options)
    },
    getHonorAnalysisList: (data, options) => {
        return post('/data_analysis/honor/get_list', data, options)
    },
    getMiGlobalAnalysisList: (data, options) => {
        return post('/data_analysis/mi_global/get_list', data, options)
    },
    getPlatAnalysisList: (data, options) => {
        return post('/data_analysis/plat/get_list', data, options)
    },
    // 导出
    exportOPPOAnalysis: (data, options) => {
        return post('/data_analysis/oppo/export', data, options)
    },
    exportMiAnalysis: (data, options) => {
        return post('/data_analysis/mi/export', data, options)
    },
    exportMiv4Analysis: (data, options) => {
        return post('/data_analysis/mi_v4/export', data, options)
    },
    
    exportVivoAnalysis: (data, options) => {
        return post('/data_analysis/vivo/export', data, options)
    },
    exportHuaweiAnalysis: (data, options) => {
        return post('/data_analysis/huawei/export', data, options)
    },
    exportIQiYiAnalysis: (data, options) => {
        return post('/data_analysis/iqiyi/export', data, options)
    },
    exportAppleAnalysis: (data, options) => {
        return post('/data_analysis/apple/export', data, options)
    },
    exportHuaweiADSAnalysis: (data, options) => {
        return post('/data_analysis/huaweiads/export', data, options)
    },
    exportHonorAnalysis: (data, options) => {
        return post('/data_analysis/honor/export', data, options)
    },
    exportMiGlobalAnalysis: (data, options) => {
        return post('/data_analysis/mi_global/export', data, options)
    },
    exportPlatAnalysis: (data, options) => {
        return post('/data_analysis/plat/export', data, options)
    },
    // 保存模板
    addTemplate: (data, options) => {
        let apiUrl = '/data_analysis/template/plat/add';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/add';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/add';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/add';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/add';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/add';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/add';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/add';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/add';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/add';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/add';
            }
        }
        return post(apiUrl, data, options)
    },
    // 分享模板（复制副本制）data: { plat_id, template_ids, to_uids }
    shareTemplate(data, options){
        let apiUrl = '/data_analysis/template/plat/share';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/share';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/share';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/share';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/share';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/share';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/share';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/share';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/share';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/share';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/share';
            }
        }
        return post(apiUrl, data, options)
    },
    // 模板分享-搜索用户（全员，含超管）data: { search }
    searchShareUser(data, options){
        return get('/data_analysis/template/share_user_search', data, options)
    },
    // 模板分享-收件箱列表（待接收，按分享人分组）
    getShareInbox(data, options){
        return get('/data_analysis/template/share_inbox_list', data, options)
    },
    // 模板分享-接收 data: { share_ids }
    acceptShare(data, options){
        return post('/data_analysis/template/share_accept', data, options)
    },
    // 模板分享-拒绝 data: { share_ids }
    rejectShare(data, options){
        return post('/data_analysis/template/share_reject', data, options)
    },
    // 获取模板列表
    getTemplateList(data,options){
        let apiUrl = '/data_analysis/template/plat/list';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/list';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/list';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/list';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/list';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/list';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/list';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/list';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/list';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/list';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/list';
            }
        }
        return get(apiUrl,data,options)
    },
    //修改模板名称
    modifyTemplateName(data,options){
        let apiUrl = '/data_analysis/template/plat/modify_name';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/modify_name';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/modify_name';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/modify_name';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/modify_name';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/modify_name';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/modify_name';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/modify_name';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/modify_name';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/modify_name';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/modify_name';
            }
        }
        return post(apiUrl,data,options)
    },
    //置顶&取消置顶模板
    topTemplate(data,options){
        let apiUrl = '/data_analysis/template/plat/set_top';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/set_top';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/set_top';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/set_top';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/set_top';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/set_top';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/set_top';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/set_top';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/set_top';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/set_top';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/set_top';
            }
        }
        return post(apiUrl,data,options)
    },
    //删除模板
    deleteTemplate(data,options){
        let apiUrl = '/data_analysis/template/plat/del';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/del';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/del';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/del';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/del';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/del';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/del';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/del';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/del';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/del';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/del';
            }
        }
        return post(apiUrl,data,options)
    },
    // 获取模板详情
    getTemplateInfo(data,options){
        let apiUrl = '/data_analysis/template/plat/get';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/get';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/get';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/get';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/get';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/get';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/get';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/get';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/get';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/get';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/get';
            }
        }
        return get(apiUrl,data,options)
    },
    // 设置&取消设置默认模板
    setDefaultTemplate(data,options){
        let apiUrl = '/data_analysis/template/plat/set_default';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/set_default';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/set_default';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/set_default';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/set_default';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/set_default';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/set_default';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/set_default';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/set_default';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/set_default';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/set_default';
            }
        }
        return post(apiUrl,data,options)
    },
    //  获取默认模板详情
    getDefaultTemplate(data,options){
        let apiUrl = '/data_analysis/template/plat/get_default';
        if(data.plat_id){
            if(data.plat_id=='1'){
                apiUrl = '/data_analysis/template/oppo/get_default';
            }else if(data.plat_id=='3'){
                apiUrl = '/data_analysis/template/vivo/get_default';
            }else if(data.plat_id=='4'){
                apiUrl = '/data_analysis/template/huawei/get_default';
            }else if(data.plat_id=='7'){
                apiUrl = '/data_analysis/template/mi/get_default';
            }else if(data.plat_id=='8'){
                apiUrl = '/data_analysis/template/iqiyi/get_default';
            }else if(data.plat_id=='9'){
                apiUrl = '/data_analysis/template/apple/get_default';
            }else if(data.plat_id=='10'){
                apiUrl = '/data_analysis/template/huaweiads/get_default';
            }else if(data.plat_id=='11'){
                apiUrl = '/data_analysis/template/honor/get_default';
            }else if(data.plat_id=='37'){
                apiUrl = '/data_analysis/template/mi_v4/get_default';
            }else if(data.plat_id=='12'){
                apiUrl = '/data_analysis/template/mi_global/get_default';
            }
        }
        return get(apiUrl,data,options)
    },

    // 表格内筛选-内容类列表接口
    getOPPOSecondConditions: (data, options) => {
        return post('/data_analysis/oppo/get_second_condition', data, options)
    },
    getMiSecondConditions: (data, options) => {
        return post('/data_analysis/mi/get_second_condition', data, options)
    },
    getMiv4SecondConditions: (data, options) => {
        return post('/data_analysis/mi_v4/get_second_condition', data, options)
    },
    getVivoSecondConditions: (data, options) => {
        return post('/data_analysis/vivo/get_second_condition', data, options)
    },
    getHuaweiSecondConditions: (data, options) => {
        return post('/data_analysis/huawei/get_second_condition', data, options)
    },
    getIQiYiSecondConditions: (data, options) => {
        return post('/data_analysis/iqiyi/get_second_condition', data, options)
    },
    getAppleSecondConditions: (data, options) => {
        return post('/data_analysis/apple/get_second_condition', data, options)
    },
    getHuaweiADSSecondConditions: (data, options) => {
        return post('/data_analysis/huaweiads/get_second_condition', data, options)
    },
    getHonorSecondConditions: (data, options) => {
        return post('/data_analysis/honor/get_second_condition', data, options)
    },
    getPlatSecondConditions: (data, options) => {
        return post('/data_analysis/plat/get_second_condition', data, options)
    },
    getMiGlobalSecondConditions: (data, options) => {
        return post('/data_analysis/mi_global/get_second_condition', data, options)
    },
    // 窗口是否展开收缩
    getConditionAreaState: (data, options) => {
        return get('/data_analysis/get_condition_area_state', data, options)
    },
    setConditionAreaState: (data, options) => {
        return post('/data_analysis/set_condition_area_state', data, options)
    },
}
